import React from "react";
import { FaEnvelope, FaMapMarkerAlt, FaPhoneAlt } from "react-icons/fa";
import contactHero from "../images/contact-hero.jpg";
import { Hero, SectionHeader } from "../components/PremiumSections";
import SEO from "../components/SEO";

const emailTo = "info@dsglobalmachines.com";
const inquiryTypes = ["Industrial Machinery", "OEM Manufacturing", "Fabrication", "Porcelain Tiles", "General Inquiry"];

export default function Contact() {
  return (
    <main className="bg-white">
      <SEO title="Contact DS Global Machines | Industrial Sourcing & OEM Manufacturing" description="Contact DS Global Machines for OEM manufacturing, industrial fabrication, porcelain tile sourcing, paper machinery, and global procurement inquiries." path="/contact" keywords={["contact OEM manufacturer", "industrial sourcing contact", "fabrication inquiry", "porcelain tile sourcing inquiry"]} />
      <Hero
        eyebrow="Contact"
        title="Start a sourcing, manufacturing, or engineering conversation."
        text="For machinery, OEM manufacturing, fabrication, porcelain tiles, and global sourcing inquiries, contact DS Global Machines directly by email or phone."
        image={contactHero}
        actions={[{ label: "Email Us", to: `mailto:${emailTo}` }, { label: "Explore Solutions", to: "/solutions" }]}
      />

      <section className="px-6 py-24">
        <div className="mx-auto grid max-w-7xl gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:items-start">
          <div>
            <SectionHeader
              eyebrow="Contact information"
              title="Send your inquiry directly to our team."
              text="Email is the best way to share technical details, drawings, product photos, specifications, quantities, and sourcing documents."
            />
            <div className="mt-8 grid gap-4">
              <a href={`mailto:${emailTo}`} className="flex items-center gap-4 rounded border border-slate-200 bg-white p-5 shadow-sm transition hover:border-[#b8894d]">
                <span className="grid h-12 w-12 place-items-center rounded bg-[#f4efe7] text-[#9a6a35]"><FaEnvelope /></span>
                <span><span className="block text-xs font-semibold uppercase tracking-[0.2em] text-[#9a6a35]">Email</span><span className="text-lg font-semibold text-[#101820]">{emailTo}</span></span>
              </a>
              <div className="flex items-center gap-4 rounded border border-slate-200 bg-white p-5 shadow-sm">
                <span className="grid h-12 w-12 place-items-center rounded bg-[#f4efe7] text-[#9a6a35]"><FaPhoneAlt /></span>
                <span><span className="block text-xs font-semibold uppercase tracking-[0.2em] text-[#9a6a35]">Phone</span><span className="text-lg font-semibold text-[#101820]">+1 (385) 461 4051</span></span>
              </div>
              <div className="flex items-center gap-4 rounded border border-slate-200 bg-white p-5 shadow-sm">
                <span className="grid h-12 w-12 place-items-center rounded bg-[#f4efe7] text-[#9a6a35]"><FaMapMarkerAlt /></span>
                <span><span className="block text-xs font-semibold uppercase tracking-[0.2em] text-[#9a6a35]">U.S. Coordination</span><span className="text-lg font-semibold text-[#101820]">Eagle Mountain, Utah, USA</span></span>
              </div>
            </div>
          </div>

          <div className="rounded border border-slate-200 bg-slate-50 p-8">
            <h2 className="text-2xl font-semibold text-[#101820]">What to include in your email</h2>
            <p className="mt-4 leading-8 text-slate-600">
              Please include your company name, location, product or service category, drawings or photos if available, quantity, destination, timeline, and any quality or documentation requirements.
            </p>
            <div className="mt-8">
              <p className="text-sm font-semibold uppercase tracking-[0.2em] text-[#9a6a35]">Inquiry categories</p>
              <div className="mt-4 grid gap-3 sm:grid-cols-2">
                {inquiryTypes.map((item) => <div key={item} className="rounded border border-slate-200 bg-white p-4 text-sm font-semibold text-slate-800">{item}</div>)}
              </div>
            </div>
            <a href={`mailto:${emailTo}?subject=${encodeURIComponent("Website Inquiry - DS Global Machines")}`} className="mt-8 inline-flex w-full items-center justify-center rounded bg-[#101820] px-6 py-3 text-sm font-semibold text-white hover:bg-[#243448]">
              Email DS Global Machines
            </a>
          </div>
        </div>
      </section>

      <section className="bg-slate-50 px-6 py-16">
        <div className="mx-auto max-w-7xl rounded border border-slate-200 bg-white p-8">
          <h2 className="text-xl font-semibold text-[#101820]">Manufacturing Network</h2>
          <p className="mt-4 leading-7 text-slate-600">
            India and international supplier coordination for machinery, fabrication, engineered components, building materials, and export-ready programs.
          </p>
        </div>
      </section>
    </main>
  );
}

